import { post, get } from '../helpers/fetchServicesMethods';
import { url } from '../reducers/url';
import axios from 'axios';

async function saveState(data) {
    try {
        let apiUrl = 'do=gqresult2.save_state&format=json';
        return await post(apiUrl, data)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function loadVariationReport(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/vmreport';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function variationAnalysisOps(data) {
    try {
        let apiUrl = 'do=gqft.vm_report_ops&format=json&id=' + data.dbId;
        return await post(apiUrl, data, null, null)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}


async function loadResultState(dbId, reportId) {
    let apiUrl = 'do=gqresult2.get_state&format=json&db=' + dbId + '&report=' + reportId;
    try {
        return await get(apiUrl)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function getApi(dbId, history) {
    let apiUrl = 'do=gqresult2.get_GQApi_info&format=json&db=' + dbId;
    try {
        return await get(apiUrl, history)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function getAuthInfo(dbId, history) {
    let apiUrl = 'do=gqresult2.get_auth_info&format=json&db=' + dbId;
    try {
        return await get(apiUrl)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function getAuthInfoAB(wfId) {
    let apiUrl = 'do=gqresult2.get_auth_info_4abov&format=json&workflowId=' + wfId;
    try {
        return await get(apiUrl)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function updateLastAccess(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/workflow/updateLastAccess';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function getABReports(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/getABReportNames';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function exportABVariants(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/exportVariant';
        return await post(apiUrl, data, null, apiKey ,"arraybuffer")
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function makeOverviewCall(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/overview';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function getAlignmentDescriptions(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/AlignmentDescriptions';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function makeCDRVariationsCall(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/cdrvariations';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function makeCDRCombinationsCall(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/cdrCombinations';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function matchingDocumentsAll(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/matchingDocumentsAll';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function matchingDocuments(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/matchingDocuments';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function saveABReport(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/saveABReport';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function editABReport(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/editABReport';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function delABReport(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/delABReport';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function matchingSequences(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/matchingSequences';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function getSummary(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/summary';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function loadAbReport(data, apiKey){
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/loadABReport';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function getStats(apiName, data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/' + apiName;
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function saveAnnotation(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/saveAnnotation';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

/**
 * Get the results for Highlight Text function
 *
 * @param data, combined of workflowId/userId/searchValue
 * @param apiKey, for discover Authorization
 * @returns {Promise<T>} the results for Highlight Text function
 */
async function searchText(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/searchText';
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function exportDocs(data, type, apiKey, contentType, onProgress, signal) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/' + type;
        return await post(apiUrl, data, null, apiKey, contentType, onProgress, signal)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function countCheckedRecords(data, history, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/countCheckedAnnatations';
        return await post(apiUrl, data, history, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function saveFilteredResult(data) {
    try {
        let apiUrl = 'do=gqft.save_filtered_result&format=json';
        return await post(apiUrl, data)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function getItems(data, apiKey, history) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/items';
        return await post(apiUrl, data, history, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function clearAnnotation(data, apiKey, history) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/clearAnnotation';
        return await post(apiUrl, data, history, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function reportDataIssue(data) {
    let apiUrl = 'do=gqhelp.send_content_feedback&format=json';
    try {
        return await post(apiUrl, data,null)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function createResultReport(data, apiKey) {
    return resultReportApi('createResultReport', data, apiKey);
}

async function saveResultReport(data, apiKey) {
    return resultReportApi('saveResultReport', data, apiKey);
}

async function updateResultReport(data, apiKey) {
    return resultReportApi('updateResultReport', data, apiKey);
}

async function loadResultReport(data, apiKey) {
    return resultReportApi('loadResultReport', data, apiKey);
}

async function removeResultReport(data, apiKey) {
    return resultReportApi('removeResultReport', data, apiKey);
}

async function getReportNames(data, apiKey) {
    return resultReportApi('getReportNames', data, apiKey);
}

async function resultReportApi(methodName, data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/' + methodName;
        return await post(apiUrl, data, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error:", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function exportClustal(data, onProgress, signal) {
    try {
        let apiUrl = 'do=gqft.export_clustalo&format=json';
        //let postData = {data: data};
        return await post(apiUrl, data, null, null, null, onProgress, signal)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function downloadClustal(file, output, contentType) {
    try {
        let apiUrl = 'do=gqft.download_clustalo' + (output === 'PIM' ? '' : '&format=json');
        let postData = {file: file, output: output};
        return await post(apiUrl, postData, null, null, contentType)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function getSubjectSequenceHits(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/subjectSequenceHits';
        return await post(apiUrl, data, null,apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function getSubjectSequenceHitsBatch(data, subjectSeqIds, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/subjectSequenceHits';
        console.log('getSubjectSequenceHitsBatch called with url:', apiUrl);    
        return await post(apiUrl, { ...data, subjectSeqIds }, null, apiKey)
            .then((response) => { return response; })
            .catch((error) => { console.log("error::", error); });
    } catch (error) {
        console.error(error);
    }
}

// Fetches a disclosed sequence's raw residues directly from the source patent database
// (cat:GQ_PATENT), independent of whether it was ever a hit in a search's result set.
// SEQ ID NO is zero-padded to 4 digits to build the composite SEQUENCE_ID (e.g. "US20260185093-0615").
async function getDisclosedSequenceBySeqId(patentNumber, seqIdNo, history) {
    try {
        const compositeId = `${patentNumber}-${String(seqIdNo).padStart(4, '0')}`;
        const apiUrl = url.seqIdRawSequence.replace('**', encodeURIComponent(compositeId));
        console.log('[SeqIdPopup] GET (raw sequence)', apiUrl);
        return await get(apiUrl, history)
            .then((response) => {
                console.log('[SeqIdPopup] raw sequence response:', response);
                return response;
            })
            .catch((error) => {
                console.log('[SeqIdPopup] raw sequence error::', error?.response?.status, error?.response?.data || error?.message || error);
            });
    } catch (error) {
        console.error('[SeqIdPopup] raw sequence unexpected error::', error);
    }
}

async function getAllSubjectSequenceHits(data, apiKey) {
    try {
        // Reuse the existing /subjectSequenceHits endpoint.
        // Passing subjectSeqId: null tells the backend to return all subjects.
        let apiUrl = process.env.REACT_APP_BASE_URL + 'jnrb/subjectSequenceHits';
        return await post(apiUrl, { ...data, subjectSeqId: null }, null, apiKey)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log("error::", error);
            });
    } catch (error) {
        console.error(error);
    }
}

async function translateAbstract(data, apiKey) {
    try {
        let apiUrl = process.env.REACT_APP_BASE_URL+ 'jnrb/translateAbstract';
        let headers = { 'Content-Type': 'application/json' };
        if (apiKey) headers['Authorization'] = 'Bearer ' + apiKey;
        const response = await axios.post(apiUrl, data, { headers, withCredentials: true });
        return response.data;
    } catch (error) {
        console.error(error);
    }
}



const DiscoverService = {
    saveState,
    updateLastAccess,
    loadResultState,
    getApi,
    getAuthInfo,
    getABReports,
    makeOverviewCall,
    makeCDRVariationsCall,
    makeCDRCombinationsCall,
    matchingDocumentsAll,
    matchingDocuments,
    matchingSequences,
    loadAbReport,
    saveABReport,
    editABReport,
    delABReport,
    getSummary,
    getStats,
    saveAnnotation,
    getAuthInfoAB,
    searchText,
    exportDocs,
    countCheckedRecords,
    saveFilteredResult,
    getItems,
    clearAnnotation,
    variationAnalysisOps,
    loadVariationReport,
    reportDataIssue,
    getAlignmentDescriptions,
    exportABVariants,
    createResultReport,
    updateResultReport,
    saveResultReport,
    loadResultReport,
    removeResultReport,
    getReportNames,
    exportClustal,
    downloadClustal,
    translateAbstract,
    getSubjectSequenceHits,
    getSubjectSequenceHitsBatch,
    getAllSubjectSequenceHits,
    getDisclosedSequenceBySeqId
};

export default DiscoverService;
